import React, { SVGProps } from 'react'
const SvgExternalLink = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill={props.fill || 'var(--color-cta)'} fillRule="nonzero">
      <path d="M10.562 13.966a.75.75 0 0 0 .984.067l.077-.067 8.485-8.486a.75.75 0 0 0-.983-1.128l-.077.068-8.486 8.485a.75.75 0 0 0 0 1.06Z" />
      <path d="M11.05 4.243a.75.75 0 0 0 .639.742l.11.008h7.736v7.735a.75.75 0 0 0 .64.742l.11.008a.75.75 0 0 0 .742-.639l.008-.11V4.242a.75.75 0 0 0-.639-.742l-.11-.008H11.8a.75.75 0 0 0-.75.75ZM7.467 6.25a.75.75 0 0 1 .101 1.493l-.101.007H4.75v11.5h11.5v-2.717a.75.75 0 0 1 .648-.743l.102-.007a.75.75 0 0 1 .743.649l.007.101V20a.75.75 0 0 1-.648.743L17 20.75H4a.75.75 0 0 1-.743-.648L3.25 20V7a.75.75 0 0 1 .648-.743L4 6.25h3.467Z" />
    </g>
  </svg>
)
export default SvgExternalLink
